import { Injectable, inject } from '@angular/core';

import { EventModel } from '@frontend/sports/betting-offer/feature/model';
import { CouponTypes } from '@frontend/sports/coupons/feature/models';
import { GridModel } from '@frontend/sports/grid/core/feature/model';
import { GridOption, ObservableGrid, ObservableGridFactory } from '@frontend/sports/grid/core/feature/observables';
import { setActiveGroupState } from '@frontend/sports/grid/core/feature/store';
import { Observable, map } from 'rxjs';

import { ObservableGridCustomColumnProvider } from './observable-grid-custom-column-provider';

@Injectable()
export class ObservableGridFactoryWithCoupons extends ObservableGridFactory {
    observableGridCustomColumnProvider = inject(ObservableGridCustomColumnProvider);
    fromCouponResponse(id: string, fixtures?: any[], options: any = {}, isPriceBoosted: boolean = false, couponType?: CouponTypes): ObservableGrid {
        if (!fixtures?.length) {
            throw new Error('Cannot map undefined fixtures');
        }

        const sport = fixtures[0].sport;
        const events = this.eventFactory.create(fixtures, {
            marketGrouping: options.marketGrouping,
            isPriceBoosted,
        });

        const grid = this.getBase(
            id,
            options,
            {
                id: sport.id,
                name: sport.name.value,
                virtual: fixtures[0].isVirtual,
                isEsport: sport.isEsport,
            },
            !!couponType,
        );
        if (couponType) {
            return this.getCouponGrid(grid, options, events, couponType);
        }

        return this.getGrid(grid, options, events);
    }

    private getCouponGrid(grid: GridModel, options: GridOption, events: Observable<EventModel[]>, couponType: CouponTypes) {
        grid = this.setConfig(grid, options);

        const source = this.getCouponSource(grid, options, events, couponType);

        const result = new ObservableGrid(grid, this.store, this.eventFactory, source);
        this.grids.push(result);

        return result;
    }

    private getCouponSource(grid: GridModel, options: GridOption, events: Observable<EventModel[]>, couponType: CouponTypes) {
        return events.pipe(map((mapped) => this.setCouponConfig(grid, options, mapped, couponType)));
    }

    private setCouponConfig(grid: GridModel, options: GridOption, events: EventModel[], couponType: CouponTypes): GridModel {
        const state = this.gridStore.get(grid.id) || { columns: [], groups: [], events: {} };
        const layout = this.getLayout();
        const columns = this.observableGridCustomColumnProvider.getCustomColumns(couponType, options, events);

        this.setPlaceHolder(options, columns);
        grid = this.updateGridState(grid, layout, options, columns, state, events);
        const active = this.getActiveColumns(columns, state.columns);
        return setActiveGroupState(grid, active);
    }
}
